import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	"@keyframes pulse": {
		"0%": {
			boxShadow: `0 0 0 0 ${colors.getPrimaryColor()}`
		},
		"70%": {
			boxShadow: "0 0 0 2px"
		},
		"100%": {
			boxShadow: "0 0 0 0"
		}
	},
	buttonPrimaryColorOutLined: {
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor(("transparent")),
		color: colors.getPrimaryColor(),
		letterSpacing: 0.4,
		animation: "$pulse 2s infinite",
		"&:hover": {
			animation: "none"
		}
	}
})

export default useStyles
